import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, DialogContent, DialogTitle, DialogActions, Dialog, Grid } from '@material-ui/core';

import TextField from '@material-ui/core/TextField';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

function CreateNewDiscountPackageModal({ clientId, showModal, MODAL_TYPE }) {
    const [name, setName] = useState(null);
    const { notifySuccess, notifyError } = useNotify();
    const history = useHistory();

    const createDiscountPackage = useCallback(() => {
        doSwaggerCall('discountpackages', 'createDiscountPackage', {
            newDiscountPackage: {
                client_id: parseInt(clientId, 10),
                name,
                wholecart: false,
                discount: {
                    agencyDiscount: { amount: '', type: '' },
                    vendorDiscount: { amount: '', type: '' }
                }
            }
        })
            .then(newDiscountPackage => {
                notifySuccess('New discount package created!');
                showModal(MODAL_TYPE.NONE);
                history.push(`/admin/client/${clientId}/discountpackages/${newDiscountPackage.id}`);
            })
            .catch(err => {
                console.log(err);
                notifyError('Error during discount package creation!');
            });
    }, [clientId, name, notifySuccess, showModal, MODAL_TYPE.NONE, history, notifyError]);

    return (
        <form>
            <Dialog
                aria-labelledby="client-modal"
                open
                onClose={() => showModal(MODAL_TYPE.NONE)}
                maxWidth="md"
            >
                <DialogTitle>Create new discount package</DialogTitle>
                <DialogContent>
                    <form
                        id="newDiscountPackage-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            createDiscountPackage();
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    type="text"
                                    value={name}
                                    onChange={ev => setName(ev.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!name}
                        type="submit"
                        form="newDiscountPackage-form"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
}

export default CreateNewDiscountPackageModal;
